(function (app) {

    app.provider("transactionPrefillApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.getPrefillsForTransaction = function (transactionId) {
                        return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/TransactionPrefills");
                    };

                    service.getPrefillForTransaction = function(transactionPrefillId) {
                        return complianceHubApiGateway.getArray("/TransactionPrefills/" + transactionPrefillId);
                    };

                    //PUTs
                    service.updateTransactionPrefill = function (transactionPrefillId, transactionPrefill) {
                        return complianceHubApiGateway.put("/TransactionPrefills/" + transactionPrefillId, transactionPrefill);
                    };

                    //POSTs
                    service.createNewTransactionPrefill = function (transactionPrefill) {
                        return complianceHubApiGateway.post("/TransactionPrefills", transactionPrefill);
                    };

                    //DELETEs
                    service.DeleteTransactionPrefill = function(transactionId, transactionPrefillId) {
                        return complianceHubApiGateway.delete("/Transactions/" + transactionId + "/TransactionPrefills/" + transactionPrefillId);
                    };

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line